define( function() {
	"use strict";

	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/src/manipulation/var/rcheckableType.js
// module id = lAZW
// module chunks = 0